import i18next from 'i18next';
import { isDefined } from 'check-tool';
import _ from 'lodash';

import BackendError, {
  USER_NOT_FOUND,
  USER_EXISTS,
  UNKNOWN,
  PERMISSION_DENIED,
  UNAUTHENTICATED,
} from 'common/BackendError';

export const getLanguage = () => {
  const pathname = window.location.pathname;
  const urlArr = pathname.split('/');
  
  if (isDefined(urlArr[1]) && (urlArr[1] === 'ru' || urlArr[1] === 'uk' || urlArr[1] === 'en')) {
    i18next.changeLanguage(urlArr[1]);
    return urlArr[1];
  }
  i18next.changeLanguage('en');
  return 'en';
};

export const getUrl = () => {
  let result = [];
  const pathname = window.location.pathname;
  const urlArr = pathname.split('/');

  if (isDefined(urlArr[1]) && (urlArr[1] === 'ru' || urlArr[1] === 'uk' || urlArr[1] === 'en') && isDefined(urlArr[2]) && !isDefined(urlArr[3])) {
    result.push(urlArr[2]);
  }

  if (isDefined(urlArr[1]) && urlArr[1] !== 'ru' && urlArr[1] !== 'uk' && urlArr[1] !== 'en' && !isDefined(urlArr[2])) {
    result.push(urlArr[1]);
  }

  if (isDefined(urlArr[1]) && (urlArr[1] === 'ru' || urlArr[1] === 'uk' || urlArr[1] === 'en') && isDefined(urlArr[2]) && isDefined(urlArr[3])) {
    result.push(urlArr[2]);
    result.push(urlArr[3]);
  }

  if (isDefined(urlArr[1]) && urlArr[1] !== 'ru' && urlArr[1] !== 'uk' && urlArr[1] !== 'en' && isDefined(urlArr[2])) {
    result.push(urlArr[1]);
    result.push(urlArr[2]);
  }

  return result;
};

export const getBackendError = (error) => {
  if (_.isNil(error)) {
    return new BackendError('We hit a snag. We are working on it', UNKNOWN);
  }

  if (_.isEmpty(error.code)) {
    return new BackendError('We hit a snag. We are working on it', UNKNOWN);
  }

  if (error.code.indexOf('firestore') > -1) {
    switch (error.code) {
      case 'firestore/not-found': {
        return new BackendError('We can not find what you are looking for.', USER_NOT_FOUND);
      }
      case 'firestore/already-exists': {
        return new BackendError('Record you are trying to create already exist.', USER_EXISTS);
      }
      case 'firestore/permission-denied': {
        return new BackendError("You dont't have permission to access this.", PERMISSION_DENIED);
      }
      case 'firestore/unauthenticated': {
        return new BackendError("You dont't have permission to access this.", UNAUTHENTICATED);
      }
      default: {
        console.log(error);
        return new BackendError('We hit a snag. We are working on it', UNKNOWN);
      }
    }
  }
  console.log(error);
  return new BackendError('We hit a snag. We are working on it', UNKNOWN);
};
